// src/services/applicationService.js
import api from './api';

// ============ LECTURE (publique) ============

export const getApplications = async ({ all = false } = {}) => {
  const params = all ? '?all=1' : '';
  const res = await api.get(`/applications${params}`);
  return res.data;
};

export const getApplication = async (id) => {
  const res = await api.get(`/applications/${id}`);
  return res.data;
};

// ============ ADMIN — ÉCRITURE ============

export const createApplication = async (data) => {
  const res = await api.post('/applications', data);
  return res.data;
};

export const updateApplication = async (id, data) => {
  const res = await api.put(`/applications/${id}`, data);
  return res.data;
};

export const updateStatut = async (id, statut) => {
  const res = await api.patch(`/applications/${id}/statut`, { statut });
  return res.data;
};

export const toggleApplication = async (id) => {
  const res = await api.patch(`/applications/${id}/toggle`);
  return res.data;
};

export const deleteApplication = async (id) => {
  const res = await api.delete(`/applications/${id}`);
  return res.data;
};

// ============ UPLOAD VIA BACKEND (comme Publications) ============

export const uploadLogo = async (file) => {
  const formData = new FormData();
  formData.append('logo', file); // 'logo' correspond à upload.single('logo')
  
  try {
    const response = await api.post('/upload/upload-logo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: 30000, // 30 secondes pour l'upload
    });
    
    return response.data.url;
  } catch (error) {
    console.error('❌ Erreur upload via backend:', error);
    
    if (error.response) {
      throw new Error(error.response.data?.error || 'Erreur lors de l\'upload');
    } else if (error.request) {
      throw new Error('Le serveur ne répond pas. Vérifiez votre connexion.');
    } else {
      throw new Error('Erreur lors de l\'upload du logo.');
    }
  }
};